// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1SM99","title":"Images45_title__1KqLw","images":"Images45_images__2GtkY"};